import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig,
} from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AccountOverviewModule } from '../account-overview/account-overview.module';
import { CustomUserRegistrationModule } from '../custom-user-registration/custom-user-registration.module';
import { NoMouseScrollModule } from '../shared/directives/no-mouse-scroll/no-mouse-scroll.module';
import { CheckoutModule } from '../shared/modules/checkout/checkout.module';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { PaymentMethodModule } from '../shared/modules/payment-method/payment-method.module';
import { ReceivingHoursAlertBannerComponent } from '../shared/modules/receiving-hours-alert-banner/receiving-hours-alert-banner.component';
import { ReceivingHoursModule } from '../shared/modules/receiving-hours/receiving-hours.module';
import { CheckoutConfirmComponent } from './checkout-confirm/checkout-confirm.component';
import { CheckoutModuleComponent } from './checkout-module/checkout-module.component';
import { CustomInfluenzaComponent } from './custom-influenza/custom-influenza.component';
import { FluCartComponent } from './flu-cart/flu-cart.component';
import { FluChartsComponent } from './flu-charts/flu-charts.component';
import { FluCheckoutComponent } from './flu-checkout/flu-checkout.component';
import { FluConfirmationRightContentComponent } from './flu-confirmation-right-content/flu-confirmation-right-content.component';
import { FluConfirmationComponent } from './flu-confirmation/flu-confirmation.component';
import { FluHeaderComponent } from './flu-header/flu-header.component';
import { FluReservationDetailsComponent } from './flu-reservation-details/flu-reservation-details.component';
import { InfluenzaDashbaordFooterComponent } from './influenza-dashbaord-footer/influenza-dashbaord-footer.component';
import { InfluenzaDashboardComponent } from './influenza-dashboard/influenza-dashboard.component';
import { InfluenzaVaccineLocatorComponent } from './influenza-vaccine-locator/influenza-vaccine-locator.component';
import { OrderConfirmFluComponent } from './order-confirm-flu/order-confirm-flu.component';
import { ProductDetailsInfluenzaComponent } from './product-details-influenza/product-details-influenza.component';
import { RecurringReservationComponent } from './recurring-reservation/recurring-reservation.component';
import { ReservationOverviewComponent } from './reservation-overview/reservation-overview.component';
import { ReservationStsDetailsComponent } from './reservation-sts-details/reservation-sts-details.component';
import { SelectVaccinesComponent } from './select-vaccines/select-vaccines.component';
import { StsShippingScheduleComponent } from './sts-shipping-schedule/sts-shipping-schedule.component';
import { VerifyPaymentComponent } from './verify-payment/verify-payment.component';
import { ViewReservationComponent } from './view-reservation/view-reservation.component';
import { WaitListComponent } from './wait-list/wait-list.component';

@NgModule({
  declarations: [
    CustomInfluenzaComponent,
    InfluenzaDashboardComponent,
    SelectVaccinesComponent,
    InfluenzaDashbaordFooterComponent,
    FluCartComponent,
    FluHeaderComponent,
    FluCheckoutComponent,
    ProductDetailsInfluenzaComponent,
    FluConfirmationComponent,
    FluChartsComponent,
    FluConfirmationRightContentComponent,
    FluReservationDetailsComponent,
    WaitListComponent,
    InfluenzaVaccineLocatorComponent,
    RecurringReservationComponent,
    CheckoutModuleComponent,
    CheckoutConfirmComponent,
    VerifyPaymentComponent,
    OrderConfirmFluComponent,
    StsShippingScheduleComponent,
    ReservationOverviewComponent,
    ReservationStsDetailsComponent,
    ViewReservationComponent,
  ],
  exports: [
    CustomInfluenzaComponent,
    InfluenzaDashboardComponent,
    SelectVaccinesComponent,
    InfluenzaDashbaordFooterComponent,
    FluCartComponent,
    FluHeaderComponent,
    FluCheckoutComponent,
    ProductDetailsInfluenzaComponent,
    FluConfirmationComponent,
    FluChartsComponent,
    FluConfirmationRightContentComponent,
    FluReservationDetailsComponent,
    WaitListComponent,
    InfluenzaVaccineLocatorComponent,
    RecurringReservationComponent,
    CheckoutModuleComponent,
    CheckoutConfirmComponent,
    VerifyPaymentComponent,
    OrderConfirmFluComponent,
    StsShippingScheduleComponent,
    ReservationOverviewComponent,
    ReservationStsDetailsComponent,
    ViewReservationComponent,
  ],

  imports: [
    RouterModule,
    BaseChartDirective,
    I18nModule,
    CommonModule,
    NgbPopoverModule,
    NgbModule,
    BsDatepickerModule.forRoot(),
    BrowserModule,
    NgSelectModule,
    FluDashboardBannerModule,
    NgbModule,
    CheckoutModule,
    ReactiveFormsModule,
    FormsModule,
    CustomUserRegistrationModule,
    ReceivingHoursModule,
    PaymentMethodModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AccountOverviewModule,
    NoMouseScrollModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SelectVaccinePageComponent: {
          component: () =>
            import('./select-vaccines/select-vaccines.component').then(
              (m) => m.SelectVaccinesComponent
            ),
          guards: [AuthGuard],
        },
        Fluverifypaymentflexcomponent: {
          component: () =>
            import('./verify-payment/verify-payment.component').then(
              (m) => m.VerifyPaymentComponent
            ),
          guards: [AuthGuard],
        },
        FluviewCheckoutPageComponent: {
          component: () =>
            import('./flu-checkout/flu-checkout.component').then(
              (m) => m.FluCheckoutComponent
            ),
          guards: [AuthGuard],
        },
        FluCartMarketBannerComponent: {
          component: () =>
            import('./flu-cart/flu-cart.component').then(
              (m) => m.FluCartComponent
            ),
          guards: [AuthGuard],
        },
        FluviewCartPageComponent: {
          component: () =>
            import('./flu-cart/flu-cart.component').then(
              (m) => m.FluCartComponent
            ),

          guards: [AuthGuard],
        },
        SanofiFluDashboardBannerComponent: {
          component: () =>
            import('./influenza-dashboard/influenza-dashboard.component').then(
              (m) => m.InfluenzaDashboardComponent
            ),
          guards: [AuthGuard],
        },
        SanofiFluDashboardAlertBannerComponent: {
          component: () =>
            import('./influenza-dashboard/influenza-dashboard.component').then(
              (m) => m.InfluenzaDashboardComponent
            ),
          guards: [AuthGuard],
        },
        FluParagraphComponent: {
          component: () =>
            import('./influenza-dashboard/influenza-dashboard.component').then(
              (m) => m.InfluenzaDashboardComponent
            ),
          guards: [AuthGuard],
        },
        FluviewOrderConfirmationPageComponent: {
          component: () =>
            import('./flu-confirmation/flu-confirmation.component').then(
              (m) => m.FluConfirmationComponent
            ),
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'FluReservationDeliveryHoursBannerSlot',
      position: OutletPosition.REPLACE,
      component: ReceivingHoursAlertBannerComponent,
    }),
    provideOutlet({
      id: 'FluParaMiddleSlottest',
      position: OutletPosition.REPLACE,
      component: InfluenzaDashboardComponent,
    }),
    provideOutlet({
      id: 'SanofiFluDashboardBottomRight',
      position: OutletPosition.REPLACE,
      component: InfluenzaDashbaordFooterComponent,
    }),
    provideOutlet({
      id: 'WaitlistComponent',
      position: OutletPosition.REPLACE,
      component: WaitListComponent,
    }),
    provideOutlet({
      id: 'CenterLeftContentSlot',
      position: OutletPosition.REPLACE,
      component: CheckoutConfirmComponent,
    }),
    provideOutlet({
      id: 'ConfirmationFluPage-Leftsection',
      position: OutletPosition.REPLACE,
      component: OrderConfirmFluComponent,
    }),
    provideOutlet({
      id: 'ScheduleLaterContent', //position of required slot
      position: OutletPosition.REPLACE,
      component: StsShippingScheduleComponent,
    }),
    provideOutlet({
      id: 'EmptyCheckOutMiddleContent',
      position: OutletPosition.REPLACE,
      component: CheckoutModuleComponent,
    }),
    provideOutlet({
      id: 'FlulocatorContentSlot',
      position: OutletPosition.REPLACE,
      component: InfluenzaVaccineLocatorComponent,
    }),
    provideOutlet({
      id: 'RecurringPagePreferenceComponent',
      position: OutletPosition.REPLACE,
      component: RecurringReservationComponent,
    }),
    provideOutlet({
      id: 'FlureservationOverViewSlot',
      position: OutletPosition.REPLACE,
      component: ViewReservationComponent,
    }),
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class CustomInfluenzaModule {}
